import { render, staticRenderFns } from "./batch-brand.vue?vue&type=template&id=3f0d9972&scoped=true&"
import script from "./batch-brand.vue?vue&type=script&lang=js&"
export * from "./batch-brand.vue?vue&type=script&lang=js&"
import style0 from "./batch-brand.vue?vue&type=style&index=0&lang=stylus&rel=stylesheet%2Fstylus&"
import style1 from "./batch-brand.vue?vue&type=style&index=1&id=3f0d9972&lang=stylus&rel=stylesheet%2Fstylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f0d9972",
  null
  
)

export default component.exports